export default __webpack_public_path__ + "static/media/Help  Active - Hover.5e3ea67a.svg";